import { render } from "./PRO_Categorii.vue?vue&type=template&id=16119722&scoped=true&ts=true"
import script from "./PRO_Categorii.vue?vue&type=script&lang=ts"
export * from "./PRO_Categorii.vue?vue&type=script&lang=ts"

import "./PRO_Categorii.vue?vue&type=style&index=0&id=16119722&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16119722"]])

export default __exports__